import { useTranslation } from "react-i18next";
import { CommonPageUiLayer } from "../components/CommonPageUiLayer";
import { MunicipalHistoryLeftMenuList } from "../utils/constants";

const TABLE_1_ROWS = [
  { date: "16/04/1924", name: "Deshbandhu Chittaranjan Das" },
  { date: "01/04/1925", name: "Deshbandhu Chittaranjan Das" },
  { date: "17/07/1925", name: "Deshapriya Jatindra Mohan Sengupta" },
  { date: "01/04/1926", name: "Deshapriya Jatindra Mohan Sengupta" },
  { date: "27/04/1927", name: "Deshapriya Jatindra Mohan Sengupta" },
  { date: "02/04/1928", name: "Sri Bijoy Kumar Basu" },
  { date: "10/04/1929", name: "Deshapriya Jatindra Mohan Sengupta" },
  { date: "29/04/1930", name: "Deshapriya Jatindra Mohan Sengupta" },
  { date: "22/08/1930", name: "Netaji Subhas Chandra Bose" },
  { date: "15/04/1931", name: "Dr. Bidhan Chandra Roy" },
  { date: "11/04/1932", name: "Dr. Bidhan Chandra Roy" },
  { date: "09/04/1933", name: "Sri Santosh Kumar Basu" },
  { date: "04/07/1934", name: "Sri Nalini Ranjan Sarkar" },
  { date: "30/04/1935", name: "Sri Abul Kasem Fazlul Haque" },
  { date: "29/04/1936", name: "Sir Harisankar Paul" },
  // TODO: source date reads "28/041937" (missing a slash) — verify vs. official record.
  { date: "28/04/1937", name: "Sri Sanat K.Roy Chowdhury" },
  { date: "29/04/1938", name: "Sri A.K.M. Zakariah" },
  { date: "26/04/1939", name: "Sri Nisith Chandra Sen" },
  { date: "24/04/1940", name: "Sri Abdur Rahman Siddiqi" },
  { date: "28/04/1941", name: "Sri Phanindra Nath Brahma" },
  { date: "29/04/1942", name: "Sri Hem Chandra Naskar" },
  { date: "30/04/1943", name: "Sri Syed Badrudduja" },
  { date: "26/04/1944", name: "Sri Anandi Lal Poddar" },
  { date: "27/04/1945", name: "Sri Debendra Nath Mukherjee" },
  { date: "29/04/1946", name: "Sri Syed Mohammed Usman" },
  // TODO: source lists Sl-No as "16" again here — likely should be 26. Verify.
  { date: "29/04/1947", name: "Sri Sudhir Chandra Ray Chaudhuri" },
];

const TABLE_2_ROWS = [
  { date: "01/05/1952", name: "Sri Nirmal Chandra Chunder" },
  { date: "06/03/1953", name: "Sri Naresh Nath Mookherjee" },
  { date: "02/04/1953", name: "Sri Naresh Nath Mookherjee" },
  { date: "28/04/1954", name: "Sri Naresh Nath Mookherjee" },
  { date: "25/04/1955", name: "Sri Satish Chandra Ghosh" },
  { date: "23/04/1956", name: "Sri Satish Chandra Ghosh" },
  { date: "29/04/1957", name: "Dr. Triguna Sen" },
  { date: "18/04/1958", name: "Dr. Triguna Sen" },
  { date: "08/04/1959", name: "Sri Bejoy Kumar Banerjee" },
  { date: "08/06/1960", name: "Sri Keshab Chandra Basu" },
  { date: "28/04/1961", name: "Sri Rajendranath Majumdar" },
  { date: "18/04/1962", name: "Sri Rajendranath Majumdar" },
  { date: "08/04/1963", name: "Sri Chittaranjan Chatterjee" },
  { date: "17/04/1964", name: "Sri Chittaranjan Chatterjee" },
  { date: "26/04/1965", name: "Dr. Priti Kumar Roy Chowdhury" },
  // TODO: source date reads "225/04/1966" (extra digit) — verify vs. official record.
  { date: "25/04/1966", name: "Dr. Priti Kumar Roy Chowdhury" },
  { date: "24/04/1967", name: "Sri Gobinda Chandra Dey" },
  { date: "19/04/1968", name: "Sri Gobinda Chandra Dey" },
  { date: "13/06/1969", name: "Sri Prasanta Kumar Sur" },
  { date: "24/04/1970", name: "Sri Prasanta Kumar Sur" },
  { date: "23/04/1971", name: "Sri Shyam Sundar Gupta" },
];

const TABLE_3_ROWS = [
  { date: "30/07/1985", name: "Sri Kamal Kumar Basu" },
  { date: "30/07/1990", name: "Sri Prasanta Chatterjee" },
  { date: "15/07/1995", name: "Sri Prasanta Chatterjee" },
  { date: "12/07/2000", name: "Sri Subrata Mookherjee" },
  { date: "05/07/2005", name: "Sri Bikash Ranjan Bhattacharyya" },
  { date: "16/06/2010", name: "Sri Sovan Chatterjee" },
  { date: "18/05/2015", name: "Sri Sovan Chatterjee" },
  { date: "03/12/2018", name: "Sri Firhad Hakim" },
  { date: "28/12/2021", name: "Sri Firhad Hakim" },
];

function ElectionTableHead({ t }) {
  return (
    <thead>
      <tr className="table-warning table-bor-2">
        <th scope="col">{t("Sl-No")}</th>
        <th scope="col">{t("Date of Election")}</th>
        <th scope="col">{t("Name")}</th>
      </tr>
    </thead>
  );
}

function ElectionTable({ t, rows, note }) {
  return (
    <table className="table table-bordered">
      <ElectionTableHead t={t} />
      <tbody>
        {note && (
          <tr>
            <td colSpan={3}>{t(note)}</td>
          </tr>
        )}
        {rows.map((row, index) => (
          <tr key={index}>
            <th scope="row">{index + 1}</th>
            <td>{row.date}</td>
            <td>{t(row.name)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

const MayorsOfKolkata = () => {
  const { t } = useTranslation();
  return (
    <CommonPageUiLayer leftNavsList={MunicipalHistoryLeftMenuList}>
      <div className="container">
        <div className="row">
          <div className="inner-title2">
            <h3 className="fontSizeClass mx-3">{t("Mayors of Kolkata")}</h3>
          </div>
          <div
            className="mayor-table mayer-tb2"
            style={{ maxHeight: "450px", marginBottom: "0px" }}
          >
            <div>
              <div className="section-title title2">
                <h4 className="fontSizeClass">
                  {t(
                    "(Under the Calcutta Municipal Act, 1923 - Bengal Act III of 1923)"
                  )}
                </h4>
              </div>
              <ElectionTable
                t={t}
                rows={TABLE_1_ROWS}
                // note="(Under the Calcutta Municipal Act, 1923 - Bengal Act III of 1923)"
              />

              <div className="section-title title2">
                <h4 className="fontSizeClass">
                  {t(
                    "(Under the Calcutta Municipal Act, West Bengal Act XXXIII of 1951)"
                  )}
                </h4>
              </div>
              <ElectionTable t={t} rows={TABLE_2_ROWS} />

              <div className="section-title title2">
                <h4 className="fontSizeClass">
                  {t(
                    "(Under the Calcutta Municipal Corporation Act, 1980 West Bengal Act LIX of 1980)"
                  )}
                </h4>
              </div>
              <ElectionTable t={t} rows={TABLE_3_ROWS} />
            </div>
          </div>
        </div>
      </div>
    </CommonPageUiLayer>
  );
};

export default MayorsOfKolkata;
